var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3DcDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.356 22.528a7.856 7.856 0 100-15.712 7.856 7.856 0 000 15.712zM26.356 44.65a7.856 7.856 0 100-15.713 7.856 7.856 0 000 15.712zM26.356 67.184a7.856 7.856 0 100-15.712 7.856 7.856 0 000 15.712zM48.064 22.528a7.856 7.856 0 100-15.712 7.856 7.856 0 000 15.712zM48.064 44.65a7.856 7.856 0 100-15.713 7.856 7.856 0 000 15.712zM48.064 67.184a7.856 7.856 0 100-15.712 7.856 7.856 0 000 15.712z",
    fill: "#4A4A4A"
  })));
}
export default __webpack_public_path__ + "static/media/e3dc_drag.4db9fde5.svg";
export { SvgE3DcDrag as ReactComponent };